/* Maahi Chatbot — Phase 2 (live order lookup via Vercel API). */
(function () {
  'use strict';

  var root = document.getElementById('maahi-cb');
  if (!root) return;

  var panel = root.querySelector('.maahi-cb__panel');
  var launcher = root.querySelector('.maahi-cb__launcher');
  var closeBtn = root.querySelector('.maahi-cb__close');
  var msgList = root.querySelector('[data-messages]');
  var replies = root.querySelector('[data-quick-replies]');
  var greetingNode = root.querySelector('[data-maahi-cb-greeting]');
  var body = root.querySelector('.maahi-cb__body');

  var whatsappNumber = root.dataset.whatsapp || '';
  var supportEmail = root.dataset.email || '';
  var brand = root.dataset.brand || 'Maahi';
  var hours = root.dataset.hours || '9:00 AM – 6:00 PM IST, every day';
  var avatarUrl = root.dataset.avatar || '';
  var avatarFallback = '👩🏻';
  var greeting = (function () {
    try { return JSON.parse(greetingNode.textContent); }
    catch (e) { return 'Hi 👋 How can I help you today?'; }
  })();

  /* ───────────── FAQ content (edit freely) ───────────── */
  /* All answers below are sourced directly from the published policy
     pages (Shipping, Refund & Exchange, Silk Mark & Authenticity).
     Do not add claims that aren't in those policies. */
  var FAQS = [
    {
      id: 'shipping',
      q: 'Shipping policy',
      a: 'We ship across India and to selected international destinations, with free shipping on all prepaid orders within India. Most orders are dispatched within 2 business days, and you\'ll receive tracking details via email (and SMS or WhatsApp where applicable) once your order ships. ✨'
    },
    {
      id: 'delivery-time',
      q: 'Delivery time',
      a: 'Within India, delivery generally takes 2–8 business days, depending on your location and courier partner. For international orders, transit is generally 6–12 business days. All timelines are estimates and aren\'t guaranteed.'
    },
    {
      id: 'cod',
      q: 'Cash on Delivery',
      a: 'Cash on Delivery is available on all orders within India at an additional charge of ₹149, which is non-refundable. Standard Delivery (4–8 days) is free on prepaid orders within India, and Express Delivery (2–5 days) is ₹149.'
    },
    {
      id: 'returns',
      q: 'Returns & exchanges',
      a: 'For a change of mind, you can request a return or exchange within 5 days of delivery, provided the item is unused, unwashed, undamaged, and has its original tags and packaging. Approved change-of-mind returns are issued as store credit (valid for a lifetime, no expiry). Items bought on sale or with a discount, used products, and items without tags aren\'t eligible. Wrong or damaged items are covered separately — see below.'
    },
    {
      id: 'wrong-damaged',
      q: 'Wrong or damaged item',
      a: 'If you receive a wrong or damaged product, notify us within 5 days of delivery with your order number, photographs, and a mandatory 360° unboxing video. After verification, we\'ll offer a replacement, or a refund to your original payment method if a replacement isn\'t available. In these cases, we cover the return and replacement shipping.'
    },
    {
      id: 'international',
      q: 'International shipping',
      a: 'We ship to selected international destinations, with transit generally taking 6–12 business days. Orders ship on a Delivery Duty Unpaid (DDU) basis, so any import duties, customs charges, and local taxes are paid by the recipient. International shipping charges are calculated at checkout.'
    },
    {
      id: 'authenticity',
      q: 'Silk & authenticity',
      a: 'We offer genuine silk products. Silk Mark certification applies only to products specifically identified as Silk Mark Certified on the product page. As many pieces are handwoven, slight natural variations in weave, zari, motifs, and colour tones may occur — these are inherent features of handmade textiles, not defects.'
    },
    {
      id: 'saree-care',
      q: 'Saree care',
      a: 'Each product comes with its own care instructions — please follow them. Improper handling, washing, ironing, or storage can affect fabric quality, colour retention, texture, and longevity, so we recommend gentle care.'
    }
  ];

  /* ───────────── UI helpers ───────────── */

  function el(tag, className, attrs) {
    var n = document.createElement(tag);
    if (className) n.className = className;
    if (attrs) for (var k in attrs) n.setAttribute(k, attrs[k]);
    return n;
  }

  function scrollToBottom() {
    requestAnimationFrame(function () { body.scrollTop = body.scrollHeight; });
  }

  /* Returns "Wed 1:23 PM" — short day + time, matching the reference. */
  function currentTime() {
    var d = new Date();
    try {
      var day = d.toLocaleDateString('en-US', { weekday: 'short' });
      var time = d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
      return day + ' ' + time;
    } catch (e) {
      var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      var h = d.getHours();
      var m = d.getMinutes();
      var ampm = h >= 12 ? 'PM' : 'AM';
      h = h % 12 || 12;
      return days[d.getDay()] + ' ' + h + ':' + (m < 10 ? '0' + m : m) + ' ' + ampm;
    }
  }

  function buildAvatar() {
    var av = el('span', 'maahi-cb__msg-avatar', { 'aria-hidden': 'true' });
    if (avatarUrl) {
      var img = el('img', null, { src: avatarUrl, alt: '', loading: 'lazy', width: '30', height: '30' });
      av.appendChild(img);
    } else {
      av.textContent = avatarFallback;
    }
    return av;
  }

  function addMessage(text, who, withTime) {
    var isBot = who !== 'user';
    var msg = el('div', 'maahi-cb__msg maahi-cb__msg--' + (isBot ? 'bot' : 'user'));

    var row = el('div', 'maahi-cb__msg-row');
    if (isBot) row.appendChild(buildAvatar());
    var bubble = el('div', 'maahi-cb__bubble');
    bubble.textContent = text;
    row.appendChild(bubble);
    msg.appendChild(row);

    if (withTime !== false) {
      var time = el('div', 'maahi-cb__msg-time');
      time.textContent = currentTime();
      msg.appendChild(time);
    }

    msgList.appendChild(msg);
    scrollToBottom();
    return msg;
  }

  function showTyping() {
    var msg = el('div', 'maahi-cb__msg maahi-cb__msg--bot');
    var row = el('div', 'maahi-cb__msg-row');
    row.appendChild(buildAvatar());
    var bubble = el('div', 'maahi-cb__bubble maahi-cb__typing');
    bubble.appendChild(el('span'));
    bubble.appendChild(el('span'));
    bubble.appendChild(el('span'));
    row.appendChild(bubble);
    msg.appendChild(row);
    msgList.appendChild(msg);
    scrollToBottom();
    return msg;
  }

  function clearReplies() {
    replies.innerHTML = '';
  }

  function setReplies(items) {
    clearReplies();
    items.forEach(function (item) {
      var chip = el('button', 'maahi-cb__chip' + (item.variant ? ' maahi-cb__chip--' + item.variant : ''), { type: 'button' });
      chip.textContent = item.label;
      chip.addEventListener('click', function () {
        if (item.userEcho !== false) {
          addMessage(item.label, 'user');
        }
        clearReplies();
        if (typeof item.onClick === 'function') item.onClick();
      });
      replies.appendChild(chip);
    });
    scrollToBottom();
  }

  /* Bot speaks with a brief typing pause for naturalness. */
  function botSay(text, delay) {
    var typing = showTyping();
    return new Promise(function (resolve) {
      setTimeout(function () {
        typing.remove();
        addMessage(text, 'bot');
        resolve();
      }, delay != null ? delay : 600);
    });
  }

  /* ───────────── Conversation flows ───────────── */

  function flowGreeting() {
    msgList.innerHTML = '';
    /* Brief typing pause so the greeting feels alive instead of slapped on. */
    botSay(greeting, 500).then(function () {
      setReplies([
        { label: '📦 Manage my order', onClick: flowManageOrder },
        { label: '❓ FAQs', onClick: flowFaqs },
        { label: '💬 Talk to a person', onClick: flowSupport, variant: 'primary' }
      ]);
    });
  }

  // Google Apps Script web app (same project as the Business OS sheet sync).
  // If it is ever redeployed under a new deployment, update this /exec URL.
  var API_BASE = 'https://script.google.com/macros/s/AKfycbzJcwjs3zmOhJTujcn1i5wE2sLVZwgo__k0EltV7fXATxhCBVR0uoJzlUvnDOmjLJTbSw/exec';

  // Apps Script sends no CORS preflight response, so the request must stay a
  // "simple" one: text/plain content-type, no custom headers. The body is
  // still JSON and is parsed as JSON on the server.
  //
  // Retried because the web app is unreliable at Google's end, not ours:
  // sampled 8 identical requests and only 3 came back as JSON — the rest were
  // Google's "Sorry, unable to open the file at present" Drive page, with no
  // pattern to which ones failed. The script itself is fine; a lookup that
  // fails on one attempt returns correct order data on the next. Three tries
  // takes a ~37% success rate to roughly 75%.
  //
  // Only a non-JSON body is retried. A real answer from the script — including
  // "order not found" — is returned as-is and never re-sent.
  var API_ATTEMPTS = 3;

  function callApi(payload, attempt) {
    attempt = attempt || 1;

    return fetch(API_BASE, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify(payload),
      redirect: 'follow'
    })
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var data;
        try {
          data = JSON.parse(text);
        } catch (e) {
          if (attempt < API_ATTEMPTS) return callApi(payload, attempt + 1);
          throw new Error('apps-script-unreachable');
        }

        // Sometimes the POST is answered by the web app's GET health handler
        // instead of the action handler, giving {"ok":true,"service":"..."}.
        // That parses fine but carries no result, so without this check the
        // caller would read a missing `found` as "no such order" and tell a
        // real customer their order does not exist. Retry instead.
        if (data && data.service && typeof data.found === 'undefined') {
          if (attempt < API_ATTEMPTS) return callApi(payload, attempt + 1);
          throw new Error('apps-script-unreachable');
        }

        return data;
      })
      .catch(function (err) {
        if (err && err.message === 'apps-script-unreachable') throw err;
        if (attempt < API_ATTEMPTS) return callApi(payload, attempt + 1);
        throw err;
      });
  }

  function flowManageOrder() {
    botSay('Sure! Please enter your order number and the phone number used at checkout.').then(function () {
      showPhoneInput();
    });
  }

  function showPhoneInput() {
    clearReplies();

    /* Order number AND phone are both required. Looking up on phone alone
       would show a customer's orders to anyone who knew their number. */
    var orderWrap = el('div', 'maahi-cb__input-row');
    var orderInput = el('input', 'maahi-cb__input', {
      type: 'text', placeholder: 'Order number (e.g. 1003)', maxlength: '20'
    });
    orderWrap.appendChild(orderInput);
    replies.appendChild(orderWrap);

    var wrap = el('div', 'maahi-cb__input-row');
    var input = el('input', 'maahi-cb__input', { type: 'tel', placeholder: 'Phone number', maxlength: '15' });
    var btn = el('button', 'maahi-cb__chip maahi-cb__chip--primary', { type: 'button' });
    btn.textContent = 'Look up →';
    wrap.appendChild(input);
    wrap.appendChild(btn);
    replies.appendChild(wrap);

    /* Back chip so the user can return to the three main options
       (Manage my order / FAQs / Talk to a person) instead of being
       stuck on the phone-number prompt. */
    var backChip = el('button', 'maahi-cb__chip', { type: 'button' });
    backChip.textContent = '← Back';
    backChip.addEventListener('click', function () {
      clearReplies();
      flowGreeting();
    });
    replies.appendChild(backChip);

    scrollToBottom();
    orderInput.focus();

    function submit() {
      var orderName = orderInput.value.trim();
      var phone = input.value.trim();
      if (!orderName || !phone) return;
      clearReplies();
      addMessage('Order ' + orderName + ' · ' + phone, 'user');
      lookupOrder(orderName, phone);
    }

    btn.addEventListener('click', submit);
    function onEnter(e) { if (e.key === 'Enter') submit(); }
    orderInput.addEventListener('keydown', onEnter);
    input.addEventListener('keydown', onEnter);
  }

  function lookupOrder(orderName, phone) {
    var typing = showTyping();
    callApi({ action: 'orderLookup', orderName: orderName, phone: phone })
      .then(function (data) {
        typing.remove();
        if (!data.found) {
          var msg;
          if (data.error === 'missing-order') {
            msg = 'I need both your order number and phone number to look this up.';
          } else if (data.error === 'invalid-phone') {
            msg = 'That doesn\'t look like a valid 10-digit mobile number.';
          } else if (data.reason === 'phone-mismatch') {
            msg = 'That phone number doesn\'t match this order. Please use the number given at checkout.';
          } else {
            msg = 'I couldn\'t find that order number. Please double-check it and try again.';
          }
          addMessage(msg, 'bot');
          setReplies([
            { label: '🔄 Try again', onClick: flowManageOrder },
            whatsappReply('Message us on WhatsApp', 'I need help with my order.'),
            { label: '← Back', onClick: flowGreeting, userEcho: false }
          ]);
          return;
        }
        showOrders(data.orders);
      })
      .catch(function () {
        typing.remove();
        addMessage('Something went wrong. Please try WhatsApp for immediate help.', 'bot');
        setReplies([
          whatsappReply('Message us on WhatsApp', 'I need help with my order.'),
          { label: '← Back', onClick: flowGreeting, userEcho: false }
        ]);
      });
  }

  function showOrders(orders) {
    var count = orders.length;
    botSay('Found ' + count + ' order' + (count > 1 ? 's' : '') + ' linked to your number 🎉', 0).then(function () {
      orders.forEach(function (o, i) {
        var status = o.fulfillmentStatus || o.financialStatus || 'Processing';
        var itemList = (o.items || []).map(function (it) { return it.quantity + '× ' + it.title; }).join(', ');
        var total = o.total ? '₹' + parseFloat(o.total.amount).toLocaleString('en-IN') : '';
        var tracking = o.tracking ? '\nTracking: ' + (o.tracking.number || '') + (o.tracking.url ? ' (' + o.tracking.url + ')' : '') : '';
        var text = 'Order ' + o.name + '\nStatus: ' + status + (total ? '\nTotal: ' + total : '') + (itemList ? '\nItems: ' + itemList : '') + tracking;
        addMessage(text, 'bot', i === orders.length - 1);
      });
      setReplies([
        whatsappReply('Need more help? WhatsApp us', 'Hi! I have a question about my order.'),
        { label: '← Back to start', onClick: flowGreeting, userEcho: false }
      ]);
    });
  }

  function flowFaqs() {
    botSay('Of course — what would you like to know? 👇').then(function () {
      var chips = FAQS.map(function (f) {
        return {
          label: f.q,
          onClick: function () { showFaqAnswer(f); }
        };
      });
      chips.push({ label: '← Back', onClick: flowGreeting, userEcho: false });
      setReplies(chips);
    });
  }

  function showFaqAnswer(faq) {
    botSay(faq.a).then(function () {
      setReplies([
        { label: '❓ Another question', onClick: flowFaqs, userEcho: false },
        whatsappReply('Still need help? WhatsApp us', 'Hi! I have a question about ' + faq.q.toLowerCase() + '.'),
        { label: '← Back to start', onClick: flowGreeting, userEcho: false }
      ]);
    });
  }

  function flowSupport() {
    botSay('Our team is on WhatsApp ' + hours + '.').then(function () {
      return botSay('Tap below to start a chat — we\'ll get back to you in minutes. 💬', 600);
    }).then(function () {
      var chips = [whatsappReply('Open WhatsApp', 'Hi House of Maahi! I\'d like some help.')];
      if (supportEmail) {
        chips.push({
          label: '✉️ Email us instead',
          onClick: function () {
            window.location.href = 'mailto:' + supportEmail;
          },
          userEcho: false
        });
      }
      chips.push({ label: '← Back', onClick: flowGreeting, userEcho: false });
      setReplies(chips);
    });
  }

  function whatsappReply(label, prefill) {
    return {
      label: label,
      variant: 'whatsapp',
      userEcho: false,
      onClick: function () {
        if (!whatsappNumber) {
          botSay('It looks like WhatsApp isn\'t configured yet. Please email us at ' + (supportEmail || 'our support address') + '.');
          return;
        }
        var url = 'https://wa.me/' + whatsappNumber + '?text=' + encodeURIComponent(prefill || '');
        window.open(url, '_blank', 'noopener,noreferrer');
      }
    };
  }

  /* ───────────── Open / close ───────────── */

  var isOpen = false;
  var hasGreeted = false;

  function openPanel() {
    if (isOpen) return;
    isOpen = true;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    panel.removeAttribute('hidden');
    launcher.setAttribute('aria-expanded', 'true');
    launcher.setAttribute('aria-label', 'Close chat support');
    if (!hasGreeted) {
      hasGreeted = true;
      flowGreeting();
    }
    /* Focus the first interactive thing inside the panel for a11y. */
    setTimeout(function () {
      var firstChip = replies.querySelector('.maahi-cb__chip');
      if (firstChip) firstChip.focus({ preventScroll: true });
    }, 280);
  }

  function closePanel(viaKeyboard) {
    if (!isOpen) return;
    isOpen = false;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    launcher.setAttribute('aria-expanded', 'false');
    launcher.setAttribute('aria-label', 'Open chat support');
    /* Hide panel from AT after transition */
    setTimeout(function () { if (!isOpen) panel.setAttribute('hidden', ''); }, 280);
    /* Focus must come back to the launcher so keyboard users are not dumped at
       the top of the page. But the browser paints :focus-visible on programmatic
       focus even after a mouse/touch close, leaving a ring around the avatar with
       no keyboard user to serve. Flag pointer closes so CSS can drop the ring;
       the next key press clears the flag and keyboard users get it back. */
    if (!viaKeyboard) launcher.classList.add('maahi-cb__launcher--no-ring');
    launcher.focus({ preventScroll: true });
  }

  /* Launcher opens only — close is handled by the × in the header (or ESC).
     Avoids the confusing "two ways to close" UX. */
  launcher.addEventListener('click', function () { if (!isOpen) openPanel(); });
  closeBtn.addEventListener('click', function () { closePanel(false); });
  document.addEventListener('keydown', function (e) {
    launcher.classList.remove('maahi-cb__launcher--no-ring');
    if (e.key === 'Escape' && isOpen) closePanel(true);
  });
  launcher.addEventListener('blur', function () {
    launcher.classList.remove('maahi-cb__launcher--no-ring');
  });
})();
